import { CustomFiltersModalActions } from '@modules/common/components/CustomFilterModalActions';
import { useFetchCustomFilter } from '@modules/queryBuilder/hooks';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { CustomFilterModalEditQuery } from '../CustomFilterModalEditQuery';
import { CustomFilterModalNameInput } from '../CustomFilterModalNameInput';

interface EditCustomFilterModalProps {
  whereClause?: WhereClause;
  onClose: () => void;
  filterName: string;
  filterID?: string;
}

export const EditCustomFilterModal = ({
  whereClause,
  onClose,
  filterName,
  filterID,
}: EditCustomFilterModalProps) => {
  const [updatedFilterName, setUpdatedFilterName] = useState(filterName);

  const [fetchAndApplyFilters, { dashboard }] = useFetchCustomFilter();

  useEffect(() => {
    if (filterID) {
      fetchAndApplyFilters(filterID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterID]);

  return (
    <DialogContent sx={{ p: 0 }}>
      <DialogTitle>Edit Custom Filter</DialogTitle>
      <DialogContent dividers>
        <CustomFilterModalNameInput
          filterName={updatedFilterName}
          setFilterName={setUpdatedFilterName}
          actionType="EDIT"
          createdBy={dashboard?.createdBy}
        />
        <CustomFilterModalEditQuery whereClause={whereClause} />
      </DialogContent>
      <DialogActions>
        <CustomFiltersModalActions
          onClose={onClose}
          filterName={updatedFilterName}
          showDeleteButton
          primaryAction="EDIT"
          dashboardEditToken={dashboard?.editToken}
          dashboardID={dashboard?.id}
        />
      </DialogActions>
    </DialogContent>
  );
};
